import React from 'react';
import { initials, nodeName, tileHue } from '../categoryTree.js';

// Photo of a category (4:3, focal point) or, without one, its initials on
// the sector's colour.
export function CategoryPhoto({ tree, node, lang, className = 'cat-photo' }) {
  if (node.photo) {
    return <span className={className} style={{ backgroundImage: `url("${node.photo}")`, backgroundPosition: `${node.photoX ?? 50}% ${node.photoY ?? 50}%` }} aria-hidden="true" />;
  }
  const hue = tileHue(tree, node);
  return <span className={`${className} is-empty`} style={{ background: `linear-gradient(135deg, ${hue}, #0f2a4a)` }} aria-hidden="true">{initials(nodeName(node, lang))}</span>;
}

// Clickable tile: photo, name, a small line below ("12 options inside").
export default function CategoryTile({ tree, node, lang, sub, onClick, href, LinkAs, selected, disabled }) {
  const body = (
    <>
      <CategoryPhoto tree={tree} node={node} lang={lang} />
      <span className="cat-tile-name">{nodeName(node, lang)}</span>
      {sub && <span className="cat-tile-sub">{sub}</span>}
    </>
  );
  const cls = `cat-tile${selected ? ' is-selected' : ''}${disabled ? ' is-disabled' : ''}`;
  if (LinkAs && href) return <LinkAs to={href} className={cls}>{body}</LinkAs>;
  return <button type="button" className={cls} onClick={onClick} disabled={disabled} aria-pressed={selected || undefined}>{body}</button>;
}
